export enum Constants {
  USER_SET_ADDRESS = 'USER_SET_ADDRESS',
  USER_SET_LOADING = 'USER_SET_LOADING',
  USER_SET_PROVIDER = 'USER_SET_PROVIDER',
  USER_SET_TOKEN_AMOUNT = 'USER_SET_TOKEN_AMOUNT',
  USER_SET_NATIVE_TOKEN_AMOUNT = 'USER_SET_NATIVE_TOKEN_AMOUNT',
  USER_SET_CHAIN_ID = 'USER_SET_CHAIN_ID',
  USER_SET_SDK = 'USER_SET_SDK',
  USER_SET_DASHBOARD_KEY = 'USER_SET_DASHBOARD_KEY'
}